import Model from '@/models/Model'

export default class Comment extends Model {

    resource()
    {
    return 'pos_cash_movement_ingress_type'
    }
}